module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.flagDisplayPanes) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt",
    attrs: {
      "data-toggle": "tabs"
    }
  }, _vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      class: _vm.tabTitleClass[index]
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.switchPane(index)
        }
      }
    }, [_vm._v(_vm._s(pane.buttonLabel[_vm.actualLanguage]))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, _vm._l((_vm.panes), function(pane, index1) {
    return _c('div', {
      class: _vm.tabContentClass[index1]
    }, [_c('h3', {
      staticClass: "font-w300 push-15"
    }, [_vm._v(" " + _vm._s(pane.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((pane.tilesIndicator), function(tile) {
      return _c('div', {
        staticClass: "col-xs-6 col-sm-4 col-lg-3"
      }, [_c('a', {
        staticClass: "block block-link-hover2 text-center"
      }, [_c('div', {
        staticClass: "block-content block-content-full",
        class: tile.colorBackground
      }, [_c('div', {
        staticClass: "font-w600 text-white-op push-5-t"
      }, [_vm._v(_vm._s(tile.label[_vm.actualLanguage]))]), _vm._v(" "), _c('i', {
        staticClass: "fa-2x text-white",
        class: tile.favIcon
      }), _vm._v(" "), _c('div', {
        staticClass: "h4 text-white"
      }, [_vm._v(_vm._s(tile.value) + " " + _vm._s(tile.valueSufix))])])])])
    }), _vm._v(" "), _vm._l((pane.graphs), function(graph) {
      return _c('div', [(graph.type == 'LineSingle') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-line-single-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'LineMultiple') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-line-multiple-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'BarSingle') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-bar-single-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'BarMultiple') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-bar-multiple-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e()])
    })], 2)
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a8f297c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ApiDevicePanesV1p00.vue
// module id = 1546
// module chunks = 4